<div class="container" (keydown)="keyDownFunction($event)">
    <div class="row">
        <div class="col-24">
            <h1 class="medium">Confirm the Enrollment Details Below</h1>
        </div>
    </div>
    <button #focusableEleTop class="focusable-element"></button>
    <div class="row">
        <div class="col-24" *ngIf="hasError">
            <div class="alert danger">
                <p><em>Error Message:</em></p>
                <ul>
                    <li *ngFor="let error of ErrorMessages"><button>{{error}}</button></li>
                </ul>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-16">
            <p class="bottom-20">Revise la siguiente información y haga clic en el botón en la parte inferior de la
                página para enviar la solicitud para su cliente, o haga clic para regresar y editar detalles.</p>
        </div>
        <div class="col-16">
            <p class="red-text"><strong>Tenga en cuenta que su inscripción aún no se ha enviado. Revise los datos y haga
                    clic en el botón Enviar en la parte inferior de la página para completar la inscripción.</strong>
            </p>
        </div>
    </div>
    <div class="row">
        <div class="col-16">
            <table class="all-border">
                <tr>
                    <td>ID del agente</td>
                    <td>{{enrollment.AGENTNAME}}</td>
                </tr>
                <tr>
                    <td>ID de entrada de datos</td>
                    <td>{{enrollment.USERNAME}}</td>
                </tr>
                <tr>
                    <td>Título</td>
                    <td>{{enrollment.TITLE}}</td>
                </tr>
                <tr>
                    <td>Nombre</td>
                    <td>{{enrollment.APPFN}}</td>
                </tr>
                <tr>
                    <td>Inicial del segundo nombre</td>
                    <td>{{enrollment.APPMI}}</td>
                </tr>
                <tr>
                    <td>Apellido</td>
                    <td>{{enrollment.APPLN}}</td>
                </tr>
                <tr>
                    <td>Numero de Medicare</td>
                    <td>{{enrollment.HICN}}</td>
                </tr>
                <tr>
                    <td>Fecha de aplicacion</td>
                    <td>{{appDate}}</td>
                </tr>
                <tr>
                    <td>Fecha efectiva</td>
                    <td>{{effDate}}</td>
                </tr>
                <tr>
                    <td>Solicitante Estado</td>
                    <td>{{enrollment.APPST}}</td>
                </tr>
                <tr>
                    <td>Plan seleccionado</td>
                    <td>{{enrollment.PLANTYPENAME}}</td>
                </tr>
                <tr>
                    <td>CUID</td>
                    <td>{{enrollment.CUID}}</td>
                </tr>
                <tr>
                    <td>Periodo Electoral</td>

                    <td>{{enrollment.ELECTION}}</td>
                </tr>
                <tr>
                    <td>Enrollment Criteria</td>
                    <td>{{enrollment.SEPREASONCD}} - {{enrollment.SEPREASONTEXT}}</td>
                </tr>
                <tr *ngIf="showSepEffDate">
                    <td>
                        Fecha SEP
                    </td>
                    <td>
                        {{sepEffDate}}
                    </td>
                </tr>
                <tr>
                    <td>
                        Tipo de inscripción
                    </td>
                    <td>
                        {{enrollment.AGENTDEX}}
                    </td>
                </tr>
                <tr>
                    <td>
                        Número de teléfono
                    </td>
                    <td>
                        {{enrollment.APPPHONE}}
                    </td>
                </tr>
                <tr>
                    <td>
                        Teléfono móvil
                    </td>
                    <td>
                        {{enrollment.CELLPHONE}}
                    </td>
                </tr>
                <tr>
                    <td>
                        Fecha de nacimiento
                    </td>
                    <td>
                        {{dob}}
                    </td>
                </tr>
                <tr>
                    <td>
                        Género
                    </td>
                    <td>
                        {{enrollment.APPGEN}}
                    </td>
                </tr>
                <tr>
                    <td>
                        Email
                    </td>
                    <td>
                        {{enrollment.APPEMAIL}}
                    </td>
                </tr>
                <tr>
                    <td>
                        Permanente Dirección 1
                    </td>
                    <td>
                        {{enrollment.APPADD1}}
                    </td>
                </tr>
                <tr>
                    <td>
                        Permanente Dirección 2
                    </td>
                    <td>
                        {{enrollment.APPADD2}}
                    </td>
                </tr>
                <tr>
                    <td>
                        Permanente Ciudad
                    </td>
                    <td>
                        {{enrollment.APPCITY}}
                    </td>
                </tr>
                <tr>
                    <td>
                        Permanente Estado
                    </td>
                    <td>
                        {{enrollment.APPST}}
                    </td>
                </tr>
                <tr>
                    <td>
                        Permanente Código postal
                    </td>
                    <td>
                        {{enrollment.APPZIP}}
                    </td>
                </tr>
                <tr>
                    <td>
                        Envío Dirección 1
                    </td>
                    <td>
                        {{enrollment.MAILADD1}}
                    </td>
                </tr>
                <tr>
                    <td>
                        Envío Dirección 2
                    </td>
                    <td>
                        {{enrollment.MAILADD2}}
                    </td>
                </tr>
                <tr>
                    <td>
                        Envío Ciudad
                    </td>
                    <td>
                        {{enrollment.MAILCITY}}
                    </td>
                </tr>
                <tr>
                    <td>
                        Envío Estado
                    </td>
                    <td>
                        {{enrollment.MAILST}}
                    </td>
                </tr>
                <tr>
                    <td>
                        Envío Código postal
                    </td>
                    <td>
                        {{enrollment.MAILZIP}}
                    </td>
                </tr>
                <tr>
                    <td>
                        Nombre de cuidado a largo plazo
                    </td>
                    <td>
                        {{enrollment.LTCFACILITY}}
                    </td>
                </tr>
                <tr>
                    <td>
                        Teléfono de atención a largo plazo
                    </td>
                    <td>
                        {{enrollment.LTCPHONE}}
                    </td>
                </tr>
                <tr>
                    <td>
                        Fecha de la Parte A de Medicare
                    </td>
                    <td>
                        {{medAdate}}
                    </td>
                </tr>
                <tr>
                    <td>
                        Fecha de la Parte B de Medicare
                    </td>
                    <td>
                        {{medBDate}}
                    </td>
                </tr>
                <tr>
                    <td>
                        Tipo de pago de prima
                    </td>
                    <td>
                        {{enrollment.PWO}}
                    </td>
                </tr>
                <tr>
                    <td>
                        Preferencia de idioma
                    </td>
                    <td>
                        {{enrollment.LANG}}
                    </td>
                </tr>
                <tr>
                    <td>
                        <!--Receives Electronic Explanation of Benefits-->
                        Recibe documentos sin papel
                    </td>
                    <td>
                        {{eob}}
                    </td>
                </tr>
                <tr>
                    <td>
                        <!--Accessible Format-->
                        Formato de comunicaciones accesible
                    </td>
                    <td>
                        {{accessible}}
                    </td>
                </tr>
                <tr>
                    <td>
                        Nombre del contacto de emergencia
                    </td>
                    <td></td>
                </tr>
                <tr>
                    <td>
                        Teléfono de contacto de emergencia
                    </td>
                    <td></td>
                </tr>
                <tr>
                    <td>
                        Relación de contacto de emergencia
                    </td>
                    <td></td>
                </tr>
                <tr>
                    <td>
                        Nombre de cobertura secundaria
                    </td>
                    <td>
                        {{enrollment.OTHCVRGNAME}}
                    </td>
                </tr>
                <tr>
                    <td>
                        ID de cobertura secundaria
                    </td>
                    <td>
                        {{enrollment.OTHCVRGID}}
                    </td>
                </tr>
                <tr>
                    <td>
                        Grupo de cobertura secundaria
                    </td>
                    <td>
                        {{enrollment.OTHCVRGGRP}}
                    </td>
                </tr>
                <tr>
                    <td>
                        Nombre del representante autorizado
                    </td>
                    <td>
                        {{enrollment.AUTHREPNAME}}
                    </td>
                </tr>
                <tr>
                    <td>
                        Teléfono de representante autorizado
                    </td>
                    <td>
                        {{enrollment.AUTHREPPHONE}}
                    </td>
                </tr>
                <tr>
                    <td>
                        Relación de representante autorizado
                    </td>
                    <td>
                        {{enrollment.AUTHREPREL}}
                    </td>
                </tr>
                <tr>
                    <td>
                        Dirección del representante autorizado
                    </td>
                    <td>
                        {{enrollment.AUTHREPADD1}}
                    </td>
                </tr>
                <tr>
                    <td>
                        Representante Autorizado Ciudad
                    </td>
                    <td>
                        {{enrollment.AUTHREPCITY}}
                    </td>
                </tr>
                <tr>
                    <td>
                        Estado representante autorizado
                    </td>
                    <td>
                        {{enrollment.AUTHREPST}}
                    </td>
                </tr>
                <tr>
                    <td>
                        Representante autorizado Zip
                    </td>
                    <td>
                        {{enrollment.AUTHREPZIP}}
                    </td>
                </tr>
                <ng-container *ngIf="visibleFrom2025">
                    <tr>
                        <td>
                            Nombre del representante individual
                        </td>
                        <td>
                            {{enrollment.INDREPNAME}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Relación con la inscrita
                        </td>
                        <td>
                            {{enrollment.displayRELTOENROLL}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Número de Productor Nacional
                        </td>
                        <td>
                            {{enrollment.NPN}}
                        </td>
                    </tr>
                </ng-container>
                <tr>
                    <td>
                        Nombre en la cuenta
                    </td>
                    <td>
                        {{enrollment.ACCHOLDERNAME}}
                    </td>
                </tr>
                <tr>
                    <td>
                        Tipo de cuenta
                    </td>
                    <td>
                        {{AccountType}}
                    </td>
                </tr>
                <tr>
                    <td>
                        Número de ruta
                    </td>
                    <td>
                        {{enrollment.ROUTINGNB}}
                    </td>
                </tr>
                <tr>
                    <td>
                        Institución financiera
                    </td>
                    <td>
                        {{enrollment.FININSTNAME}}
                    </td>
                </tr>
                <tr>
                    <td>
                        Número de cuenta
                    </td>
                    <td>
                        {{enrollment.ACCOUNTNB}}
                    </td>
                </tr>
                <tr>
                    <td>
                        Notas
                    </td>
                    <td>
                        {{enrollment.NOTES}}
                    </td>
                </tr>
                <tr>
                    <td>
                        Etnicidad
                    </td>
                    <td>
                        {{enrollment.displayEthnicity}}
                    </td>
                </tr>
                <tr>
                    <td>
                        La raza
                    </td>
                    <td>
                        {{enrollment.displayRace}}
                    </td>
                </tr>
                <tr *ngIf="visibleFrom2025">
                    <td>
                        Identidad de género
                    </td>
                    <td>
                        {{enrollment.displayCurrentGender}}
                    </td>
                </tr>
                <tr *ngIf="visibleFrom2025">
                    <td>
                        Identidad de género diferente
                    </td>
                    <td>
                        {{enrollment.CURRENTGENDEROTH}}
                    </td>
                </tr>
                <tr *ngIf="visibleFrom2025">
                    <td>
                        Autoidentidad
                    </td>
                    <td>
                        {{enrollment.displayGenderProNoun}}
                    </td>
                </tr>
                <tr *ngIf="visibleFrom2025">
                    <td>
                        Diferente identidad propia
                    </td>
                    <td>
                        {{enrollment.GENDERNPRONOUNOTH}}
                    </td>
                </tr>
            </table>

        </div>
    </div>
    <div class="row">
        <div class="col-24">
            <button class="button primary" (click)="formSubmit()"> Submit Application</button>
            <button class="button cancel" (click)="goBack()">Go Back and Make Changes</button>
        </div>
    </div>
</div>